// Some filters (e.g. group, home location) can be explicitly set to `null` to mean
// "devices with no group"/"no home location", which is distinct from the filter being
// unset (`undefined`). URLSearchParams can't represent that distinction natively, so we
// encode explicit nulls using this sentinel value.
const NULL_SENTINEL = '\0';

export function encodeNullableQueryParam(params: URLSearchParams, key: string, value: string | null | undefined): void {
  if (value === undefined) {
    return;
  }
  params.set(key, value === null ? NULL_SENTINEL : value);
}

export function decodeNullableQueryParam(value: string | null): string | null | undefined {
  if (value === null) {
    return undefined;
  }
  return value === NULL_SENTINEL ? null : value;
}
